import type { TwoFactorMethod } from '@contexts/auth/domain';
import type { AuthRepository } from '@contexts/auth/domain/contracts/auth.repository';
import type { UseCase } from '@contexts/shared/application';

export type GetUserTwoFactorMethodsType = UseCase<void, TwoFactorMethod[]>;

export function getUserTwoFactorMethodsBuilder(
	repository: AuthRepository
): GetUserTwoFactorMethodsType {
	return async function getUserTwoFactorMethods(): Promise<TwoFactorMethod[]> {
		return repository.getUserMethods();
	};
}
